import { createContext } from 'react';

export type SystemNotificationSeverity = 'info' | 'warning' | 'error' | 'success';

export interface SystemNotificationAction {
  label: string;
  href: string;
}

export interface SystemNotification {
  id: string;
  message: string;
  title?: string;
  dismissible?: boolean;
  severity?: SystemNotificationSeverity;
  action?: SystemNotificationAction;
}

export type NewSystemNotification = Omit<SystemNotification, 'id'> & { id?: string };

export interface SystemNotificationContextType {
  notifications: SystemNotification[];
  addNotification: (notification: NewSystemNotification) => string;
  removeNotification: (id: string) => void;
  dismissNotification: (id: string) => void;
}

export const SystemNotificationContext = createContext<SystemNotificationContextType | undefined>(undefined);
